import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { TextInput } from "../inputs/text-input"

interface TextFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof TextInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function TextField<T extends FieldValues>({ field, id, description, ...props }: TextFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <TextInput id={id} error={!!error} {...field} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  email: string;
}

<FormField
  control={form.control}
  name="email"
  render={({ field }) => (
    <TextField<FormData>
      field={field}
      id="email"
      label="Email Address"
      type="email"
      placeholder="Enter your email"
    />
  )}
/>
*/
